// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"4dbbe04a","78":"c83ef767","112":"222b94d8","167":"bccc38d0","192":"57369da3","419":"2e93c559","491":"83ff6438","597":"86bc9363","651":"d80f4549","711":"98007315","765":"1b8b8105","824":"45395459","831":"2c36a5e5","900":"1e4ac765","956":"b5f56d4b","972":"9296725c"}[chunkId] + ".chunk.js";
};